import { z } from 'zod';
import { auditFieldsShape, utcTimestampSchema, uuidSchema } from './primitives';

export const BOARD_COLUMN_KINDS = ['normal', 'completed_queue'] as const;
export const boardColumnKindSchema = z.enum(BOARD_COLUMN_KINDS);

export const boardColumnSchema = z.object({
  id: uuidSchema,
  name: z.string().min(1),
  order: z.number().int().nonnegative(),
  color: z.string().nullable(),
  /** Phosphor icon 名稱。 */
  icon: z.string().nullable(),
  description: z.string().nullable(),
  kind: boardColumnKindSchema,
  /** 收合狀態隨欄位一起備份；捲動位置只存 localStorage。 */
  collapsed: z.boolean(),
  archivedAt: utcTimestampSchema.nullable(),
  ...auditFieldsShape,
});

export const boardPlacementSchema = z.object({
  id: uuidSchema,
  taskId: uuidSchema,
  columnId: uuidSchema,
  order: z.number().int().nonnegative(),
  /** 進入完成佇列前所在的一般欄位，供取消完成時復位。 */
  columnIdBeforeCompletion: uuidSchema.nullable(),
  ...auditFieldsShape,
});

export const QUADRANTS = [
  'urgent_important',
  'important_not_urgent',
  'urgent_not_important',
  'neither',
  'unclassified',
] as const;
export const quadrantSchema = z.enum(QUADRANTS);

export const matrixPlacementSchema = z.object({
  id: uuidSchema,
  taskId: uuidSchema,
  quadrant: quadrantSchema,
  order: z.number().int().nonnegative(),
  ...auditFieldsShape,
});

export type BoardColumnKind = z.infer<typeof boardColumnKindSchema>;
export type BoardColumn = z.infer<typeof boardColumnSchema>;
export type BoardPlacement = z.infer<typeof boardPlacementSchema>;
export type Quadrant = z.infer<typeof quadrantSchema>;
export type MatrixPlacement = z.infer<typeof matrixPlacementSchema>;
